import { makeApiaUsersModal2 } from '@apia/api';
import { getLabel } from '@apia/util';
import { observer } from 'mobx-react-lite';
import { usePermissionsContext } from '../Permissions';
import { SimpleButton } from '../../forms';

export const UserModalBtn = observer(() => {
  const context = usePermissionsContext();

  return (
    <SimpleButton
      disabled={context.disabled}
      variant="outline"
      onClick={() => {
        makeApiaUsersModal2()
          .openModal({
            title: window.LBL_ADD_USER,
          })
          .then((selected) => {
            context.onChangeUsers(
              selected.reduce(
                (acc, c) => {
                  const newItem = {
                    userId: c.row.id,
                    userLogin: String(c.row.cells[0].children),
                    canUpdate: false,
                  };

                  if (!acc.some((c) => c.userId === newItem.userId)) {
                    acc.push(newItem);
                  }
                  return acc;
                },
                [...context.permissions.users],
              ),
            );
          });
      }}
    >
      {getLabel('btnAddUser').text}
    </SimpleButton>
  );
});
